import { BookIcon } from './BookIcon';

/**
 * author: Google
 * id FFF82791-D12F-4643-8128-71CF5FE38C9B
 * name book
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/book.svg
 * tags
 */
export const GitRepositoryIcon = BookIcon;
export default GitRepositoryIcon